module.exports = __webpack_public_path__ + "img/190.54d354c6.jpg";